import dayjs from 'dayjs';
import { parseApiDateTime } from '@/helpers/parseApiDateTime';

export const TERMINAL_STATUS_CODES = ['ready', 'declined'];

export function isTerminalTicketStatus(status) {
  if (!status || !status.code) {
    return false;
  }
  return TERMINAL_STATUS_CODES.indexOf(status.code) !== -1;
}

export function formatSlaDuration(totalMinutes) {
  var minutes = totalMinutes;
  if (minutes < 0) {
    minutes = 0;
  }

  var days = Math.floor(minutes / 1440);
  var hours = Math.floor((minutes % 1440) / 60);
  var mins = minutes % 60;

  if (days >= 1) {
    return days + 'д ' + hours + ' ч ' + mins + 'м';
  }
  if (hours >= 1) {
    return hours + ' ч ' + mins + 'м';
  }
  return mins + 'м';
}

export function getSlaDisplayState(deadlineAt, status, now) {
  var current = now || dayjs();

  if (isTerminalTicketStatus(status) || !deadlineAt) {
    return {
      mode: 'dash',
      totalMinutes: 0,
      formatted: '—'
    };
  }

  var deadline = parseApiDateTime(deadlineAt);
  if (!deadline) {
    return {
      mode: 'dash',
      totalMinutes: 0,
      formatted: '—'
    };
  }

  var diffMs = deadline.diff(current);
  var totalMinutes = Math.floor(Math.abs(diffMs) / 60000);

  if (diffMs >= 0) {
    return {
      mode: 'countdown',
      totalMinutes: totalMinutes,
      formatted: formatSlaDuration(totalMinutes)
    };
  }

  return {
    mode: 'overdue',
    totalMinutes: totalMinutes,
    formatted: formatSlaDuration(totalMinutes)
  };
}
